angular.module('jv.Privacy.Policy.Directive', [])

.directive('jvPrivacyPolicyUrl', [
    function(){
        return {
            scope: {
                url: '='
            },

            link: function(scope, elm, attrs){
                scope.$watch('url', function(newVal, oldVal) {
                    var element = document.getElementById('privacyPolicyUrlLink');
                    if (!element) return;

                    if(newVal){
                        element.href=newVal;
                        element.style.display = "inline";
                    }else if(newVal === ""){
                          if (element.parentNode) {
                                element.parentNode.removeChild(element);
                          }
                    }
                });
            }
        };
    }

]);